import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetLocationTreeResponseDto } from './dto/response/get-location-tree-response.dto';

const RESOURCE_PATH = HttpPathsEnum.RESOURCE;

class PropertiesManagementApi {
  public async getLocationTree(locationId: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/location/tree/${locationId}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetLocationTreeResponseDto>(
      request,
      GetLocationTreeResponseDto
    );
  }
}
export default new PropertiesManagementApi();
